import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Shorts'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Shorts'

export const mediaPlatformShortsRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.SHORTS,
  loader: () => ({
    crumb: t('entity:publishing.short', { count: 2 }),
  }),
})

export const mediaPlatformShortsLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformShortsRoute,
  id: 'mediaPlatformShortsLayout',
  component: Structure,
})

type MediaPlatformShortsOverviewSearch = {
  query?: string
}

export const mediaPlatformShortsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformShortsLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformShortsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
